import axios from 'axios';
import { FASTAPI_API } from '../constants';

const api = axios.create({
  baseURL: FASTAPI_API,
  withCredentials: true,
});

export { api };
